import React from "react";
import Parse from "parse";
import "./../StylesPages/profile.css";

import {
  FormControl,
  FormErrorMessage,
  Textarea,
  Spacer,
  Select,
  Input,
  Button,
  Center,
  useBreakpointValue,
  Flex,
  Text,
  useToast,
} from "@chakra-ui/react";
import "./../StylesPages/profile.css";

function ResetPassword() {
  const buttonSize = useBreakpointValue(["xs", "md"]);

  const toast = useToast();

  const handleSubmit = (e) => {
    const currentUser = Parse.User.current();
    if (currentUser) {
      Parse.User.requestPasswordReset(currentUser.get("email"))
        .then(() => {
          toast({
            title: "CHANGER LE MOT DE PASSE",
            description: "Un email vous a été envoyé",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        })
        .catch((error) => {
          alert("Error: " + error.code + " " + error.message);
        });
    }
  };

  return (
    <Flex direction={"column"} justify={"center"} align={"center"}>
      <Text
        fontFamily={"Sofia Pro"}
        fontSize="xl"
        fontWeight={"bold"}
        color="black"
        marginTop={"20px"}
      >
        Mot de passe et authentification
      </Text>
      <Button
        bg="#0080FF"
        fontFamily={"Sofia Pro"}
        color={"white"}
        borderRadius="100px"
        errorBorderColor="red.300"
        marginTop="38px"
        marginBottom="38px"
        size="xs"
        py={6}
        px={8}
        onClick={handleSubmit}
        className="changeButton"
      >
        CHANGER LE MOT DE PASSE
      </Button>
      <Text
        fontFamily={"Sofia Pro"}
        fontSize="xs"
        color="black"
        w={"80%"}
        fontWeight={"light"}
        letterSpacing={0.1}
        lineHeight={1.1}
        marginBottom={"10px"}
      >
        Assurez vous d’inclure au moins une majuscule, un chiffre et un
        caractère spécial afin de sécuriser votre nouveau mot de passe.
      </Text>
    </Flex>
  );
}

export default ResetPassword;
